module.exports = {"530927101":"勐董镇","530927102":"岩帅镇","530927103":"勐省镇","530927104":"芒卡镇","530927202":"单甲乡","530927203":"糯良乡","530927204":"勐来乡","530927205":"勐角傣族彝族拉祜族乡","530927206":"班洪乡","530927207":"班老乡","530927401":"勐省农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530927.json
// module id = 2613
// module chunks = 0